import { useQuery } from '@tanstack/react-query';
import { getSessionQueryOptions } from './sessionQueryOptions.ts';

/**
 * Shared session query hook. Subscribers use `enabled: false` (default) and read cache;
 * boot enables fetch when authenticated.
 */
export function useSessionQuery() {
  const sessionQuery = useQuery({
    ...getSessionQueryOptions,
    enabled: false,
  });

  if (!sessionQuery.data) {
    throw new Error('Session is not available in the query cache');
  }

  return sessionQuery;
}
